import React from "react";

const Avaluos_Map = () => {
  return <div className="avaluos-map-container"></div>;
};

export default Avaluos_Map;
